/**
* @Description 文件功能说明：角色组件
* @Author
* @Time 2021/6/4
**/

/* HTML */
<template>
    <div :class="{'tree-item-box': true, 'mini-box': !showBoxFlag}">

		<div class="box-bar-item" @click="toggleBox" title="展开/收起 人员分组">
			<i v-if="showBoxFlag" class="iconfont el-icon-my_left2-copy"></i>
			<i v-else class="iconfont el-icon-my_right2"></i>
		</div>

        <div class="tree-group-title">
            <span class="tree-group-name" >人员类型分组</span>
            <el-button class="tree-group-btn" icon="el-icon-circle-plus-outline" size="mini" @click="addGroup" >新增分组</el-button>
        </div>

        <div class="tree-group-item">
            <el-tree
                :props="defaultProps"
                :data="userGroups"
                node-key="id"
                :default-expand-all="true"
                :expand-on-click-node="false"
                @node-click="handleTreeNode"
            >
                <span class="custom-tree-node"
                      slot-scope="{node, data}"
                      @mouseenter="mouseenter(data)"
                      @mouseleave="mouseleave(data)"
                >
                    <span>{{data.label}}</span>
                    <span class="tree-item-button">
                        <el-button
                            type="text"
                            size="mini"
                            title="编辑"
                            v-show="data.show"
                            icon="el-icon-edit"
                            @click="() => {editGroup(data)}"
                            v-if="data.parentId!=0"
                        >
                        </el-button>
                        <el-button
                            type="text"
                            size="mini"
                            title="删除"
                            v-show="data.show"
                            icon="el-icon-delete"
                            @click="() => {remove(data)}"
                            v-if="data.parentId!=0"
                        >
                        </el-button>
                        <el-button
                            type="text"
                            size="mini"
                            title="新增人员"
                            v-show="data.show"
                            icon="el-icon-circle-plus"
                            @click="() => {addUser(data)}"
                            v-if="data.parentId!=0"
                        >新增人员
                        </el-button>
                    </span>
                </span>
            </el-tree>
        </div>

        <!--添加或编辑角色弹窗-->
        <UserGroupDialog ref="userGroupDialog" :userTypes="userTypes" @flushGroup="flushGroup"/>
        <!-- 添加账户 -->
        <UserDialog ref="userDialog" :userGroups="userGroups" @setTotal="setTotal" />
    </div>

</template>

/* JS */
<script>
    import UserGroupDialog from './UserGroupDialog'
    import ApiUser from '@/request/api-user'
    import UserDialog from './UserDialog'

    export default {

        /**
         * @Des 数据接收类型
         * @Auth
         * @Date 2021/6/4
         */
        props: {
            // 用户组集合
            userGroups: Array,
            // 用户组集合
            userTypes: Array,
            /**
             * @Des 展示box
             * @Auth
             * @Date 2021/6/5
             */
          showBoxFlag: {
            type: Boolean,
            default: function (){
              return true
            }
          },
        },

        /**
         * @Des 组件引用
         * @Auth
         * @Date 2021/6/4
         */
        components: {
            // 用户组弹窗
            UserGroupDialog,
            UserDialog
        },

        /**
         * @Des 数据定义
         * @Auth
         * @Date 2021/6/4
         */
        data() {
            return {

                /**
                 * @Des 树属性默认定义
                 * @Auth
                 * @Date 2021/6/4
                 */
                defaultProps: {
                    label: 'name',
                    children: 'children'
                },
                // 角色名
                roleName: '',
                // 删除锁
                deleteLock: false,
            }
        },

        /**
         * @Des 方法定义
         * @Auth
         * @Date 2021/6/4
         */
        methods: {
			/**
             * @Des mini max box
             * @Auth
             * @Date 2021/6/5
             */
			toggleBox() {
				this.$emit('toggleBox', !this.showBoxFlag);
			},

            /**
             * @Des 添加组
             * @Auth
             * @Date 2021/6/4
             */
            addGroup(data){
                this.$refs.userGroupDialog.openDialog(false, data);
            },

            /**
             * @Des 编辑组
             * @Auth
             * @Date 2021/6/4
             */
            editGroup(data){
                this.$refs.userGroupDialog.openDialog(true, data)
            },

            /**
             * @Des 删除组
             * @Auth
             * @Date 2021/6/4
             */
            remove(data){
                if(this.deleteLock){
                    return;
                }
                this.$confirm('确认要删除【' + data.name + '】组吗？','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteLock = true;
                    this.$request.postJsonRequest(ApiUser.deleteUserGroupApi,{
                        // typeId: data.parentId.replace("T",""),
                        groupId: data.id,
                        // projectId: this.$store.state.currentProjectId
                    }).then(result => {
                        if(result.code == 0){
                            this.$message({
                                message: '人员组【' + data.name + '】删除成功！',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                            this.flushGroup();
                        }else{
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                        this.deleteLock = false;
                    }).catch(error => {
                    	this.deleteLock = false;
                    	console.error('删除人员组异常', ApiUser.deleteUserGroupApi, error);
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除组【' + data.name + '】'
                    });
                    this.deleteLock = false;
                })
            },
            addUser(data){
                this.$refs.userDialog.openDialog('新增人员', '添加保存', 'add', data);
            },

            /**
             * @Des 处理树节点
             * @Auth
             * @Date 2021/6/4
             */
            handleTreeNode(data){
                this.$emit('setSelectVal', data);
            },
            /**
             * @Des 鼠标进入事件
             * @Auth
             * @Date 2021/6/29
             */
            mouseenter(data){
                this.$set(data, 'show', true);
            },
            /**
             * @Des 鼠标离开事件
             * @Auth
             * @Date 2021/6/29
             */
            mouseleave(data){
                this.$set(data, 'show', false)
            },
            /**
             * @Des 刷新组
             * @Auth
             * @Date 2021/6/29
             */
            flushGroup(groupId, groupName){
            	this.$emit("flushGroup", groupId, groupName);
            },
            /**
             * @Des 改变总数
             * @Auth
             * @Date 2021/6/21
             */
            setTotal(val){
                this.$emit("setTotal",val);
            },
        },

        /**
         * @Des 初始化加载
         * @Auth
         * @Date 2021/6/4
         */
        mounted() {
        }

    }
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>




// WEBPACK FOOTER //
// src/components_pages/User/UserGroupTree.vue